import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = '/relojchecador/dia-festivo';

/**
 * GET Dias Festivos Por Año
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getDiasFestivosPorAñoPag = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Dias Festivos Por Año
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getDiasFestivosPorAño = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Dias Festivos Por Año
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getDiaFestivoPorAño = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Dia Festivo Por Año
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postDiaFestivoPorAño = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Dia Festivo Por Año
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchDiaFestivoPorAño = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Dia Festivo Por Año
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteDiaFestivoPorAño = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Dia Festivo Por Año
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarDiaFestivoPorAño = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
